module.exports = __webpack_public_path__ + "static/img/95_phase_function_Paper_PointsHejduk_Prediction.d6e4d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/95_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kL0S
// module chunks = 0